import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikProps } from 'formik';

import { Button } from '@/common/components/button';
import { FieldSegmentedInput } from '@/common/components/form-controls';
import { RedeemVoucherResponseStatus } from '../../../../models/voucher';
import { ErrorSection } from '../error-section';
import { ControlListDefs, CONTROL_LIST } from './constants';
import { styles } from './styles';

const INPUT_SEGMENTS = [{ maxLength: 4 }, { maxLength: 4 }, { maxLength: 4 }];

type Props = FormikProps<ControlListDefs>;

export const Form: FC<Props> = ({ isSubmitting, submitForm, isValid, dirty, status, setStatus }) => {
  const [t] = useTranslation();

  const handleOnFocus = useCallback(() => {
    if (status !== undefined) {
      setStatus(undefined);
    }
  }, [status, setStatus]);

  const showError = status !== undefined && status !== RedeemVoucherResponseStatus.SUCCESS;
  const errorTitle =
    status === RedeemVoucherResponseStatus.HAS_ALREADY_BEEN_REDEEMED ? t('page.voucher.errorTitleAlreadyRedeemed') : t('page.voucher.errorTitleNotRecognised');

  const errorDescription =
    status === RedeemVoucherResponseStatus.HAS_ALREADY_BEEN_REDEEMED
      ? t('page.voucher.errorDescriptionAlreadyRedeemed')
      : t('page.voucher.errorDescriptionNotRecognised');

  return (
    <form css={styles}>
      <div className='control-wrapper'>
        <FieldSegmentedInput
          isFocusOnLabelEnabled={false}
          disabled={isSubmitting}
          onFocus={handleOnFocus}
          name={CONTROL_LIST.voucherId}
          segments={INPUT_SEGMENTS}
        />
      </div>

      <ErrorSection show={showError} title={errorTitle} description={errorDescription} />
      <Button className='button' type='button' disabled={!isValid || !dirty || isSubmitting} onClick={submitForm}>
        {t('button.redeem')}
      </Button>
    </form>
  );
};
